import type { Dispatch, SetStateAction } from "react";

import { compose } from "redux";

import ExportCompetitorsButton from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/ExportButton/ExportCompetitorsButton";
import { translate } from "app/filters/i18nFilter";
import AssignToUserCompetitiveButton from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/AssignToOtherUsersPanel/AssignToUserCompetitiveButton";
import AssignToUserCompetitivePanel from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/AssignToOtherUsersPanel/AssignToUserCompetitivePanel";
import { SaveToListCompetitorsButton } from "app/pages/sales-intelligence/pages/company-analysis/containers/competitors/SaveToListCompetitors/SaveToListCompetitorsButton";
import trackingService from "app/pages/sales-intelligence/services/tracking/createMultiSelectorPanelService";
import withHubspotStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withHubspotStatusCall";
import withSalesforceStatusCall from "app/pages/sales-intelligence/sub-modules/management/hocs/manage-status/withSalesforceStatusCall";
import type { ActivatedChildComponentType } from "app/pages/sales-intelligence/sub-modules/table-actions-panel/components/BaseActivatedPanel/types";

import { StyledInnerPanelContainer, StyledTableActionsPanel } from "./styles";

const TableActionsPanelCompetitors = ({ isDisabled }: { isDisabled: boolean }) => {
    const handleAssignToUser = (activate: Dispatch<SetStateAction<ActivatedChildComponentType>>) => {
        trackingService.trackMultiSelectorAssignToOtherUserClick();
        return activate(() => AssignToUserCompetitivePanel);
    };

    return (
        <StyledTableActionsPanel>
            {({ activate }) => {
                return (
                    <StyledInnerPanelContainer>
                        <SaveToListCompetitorsButton
                            isDisabled={isDisabled}
                            onActivate={activate}
                        />
                        <AssignToUserCompetitiveButton
                            isDisabled={isDisabled}
                            onActivate={activate}
                            onClick={() => handleAssignToUser(activate)}
                            tooltipContent={translate("si.multi_selector.tooltip.assign")}
                        />
                        <ExportCompetitorsButton
                            isDisabled={isDisabled}
                            onActivate={activate}
                        />
                    </StyledInnerPanelContainer>
                );
            }}
        </StyledTableActionsPanel>
    );
};

export default compose(withSalesforceStatusCall, withHubspotStatusCall)(TableActionsPanelCompetitors);
